export default __webpack_public_path__ + "static/media/6.26531d1e.png";